import { commonRoutes, privateRoutes, anonymousRoutes } from './routes';

export const routerConfig = {
  commonRoutes,
  privateRoutes,
  anonymousRoutes,
};
